/* eslint-disable jira/filename-case */
export const LOAD_START_MARK_KEY = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';

export const TRASH_AND_RESTORE_HELP_LINK =
	'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';
